import { render, staticRenderFns } from "./it-IT.vue?vue&type=template&id=38c75d9f&scoped=true&"
var script = {}
import style0 from "./it-IT.vue?vue&type=style&index=0&id=38c75d9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c75d9f",
  null
  
)

export default component.exports